import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const HeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  @media (max-width: 768px) {
    display: block;
    ${(props) =>
      props.flexOnSmallScreen &&
      css`
        display: flex;
      `}
  }
`;

export const Header = styled.h1`
  color: ${colors.fsDarkBlue};
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 42px;
  min-width: 220px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: ${(props) => props.alignItems || 'center'};
  flex-wrap: wrap;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  margin: ${(props) => props.margin || '0px'};
`;

export const InputField = styled.input`
  font-size: 16px;
  width: 50%;
  border-top: none;
  border-right: none;
  border-left: none;
  outline: none;
  color: ${colors.darkGray};
  border-radius: 0px;
  border-bottom: 1px solid rgb(136, 136, 136);

  @media (max-width: 736px) {
    width: 90vw;
  }
`;

export const DescriptionContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  width: 100%;
  margin-top: 20px;

  @media (max-width: 736px) {
    gap: 10px;
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const EmptyContainer = styled.div``;

export const FieldContainer = styled.div`
  display: grid;
`;

export const Label = styled.label`
  font-size: 13px;
  color: ${colors.darkGray};
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const TestFieldsContainer = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: flex-end;
  justify-content: space-between;

  @media (max-width: 736px) {
    display: block;
  }
`;

export const ITag = styled.i.attrs(({ icon }) => ({ className: icon }))`
  margin-right: 5px;
  color: ${(props) => props.color || colors.darkGray};
  cursor: pointer;
`;

export const QuestionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 2rem);
  justify-content: center;
  align-content: center;
  gap: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
`;

export const QuestionsSelectionButton = styled.a`
  border: 1px solid #fff;
  background: ${colors.fsDarkBlue};
  color: #fff;
  height: 40px;
  width: 40px;
  font-weight: 600;
  text-align: center;
  padding-top: 7px;
  cursor: pointer;
  :focus {
    outline: 1px !important;
  }
  :hover {
    text-decoration: none;
    color: #fff;
  }
  &:hover,
  &.active {
    box-shadow: inset 0px 0px 50px black;
  }

  ${(props) =>
    props.isActive &&
    css`
      opacity: 1 !important;
      color: white;
      background-color: ${colors.fsCyan} !important;
      transform: scale(1.2);
    `}
`;

export const AddQuestionButton = styled.button`
  border: 1px solid #fff;
  background: ${colors.fsDarkBlue};
  color: #fff;
  height: 40px;
  width: 140px;
  font-weight: 600;
  padding: 0px;
  :focus {
    outline: 1px !important;
  }

  :hover {
    background-color: ${colors.fsCyan} !important;
  }

  :disabled {
    border: none;
    background: ${colors.fsDarkBlue};
    opacity: 0.7;
    pointer-events: none;
  }
`;

export const DetailsLabel = styled.label`
  font-size: 14px;
  ${(props) =>
    props.isHeading &&
    css`
      font-weight: 600;
    `}
`;

export const QuestionDetailsContainer = styled.div`
  margin: 30px 0;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px;
  width: 50%;
  padding: 10px;
  @media (max-width: 736px) {
    width: 100%;
  }
`;

export const OptionsContainer = styled.div`
  margin-bottom: 20px;
`;

export const ParagraphContainer = styled.div`
  margin-top: 10px;
`;

export const OptionDetailsContainer = styled.div`
  display: flex;
  border: 1px solid #cccccc;
  border-bottom: none;
  padding: 5px;
  font-size: 11px;
  font-weight: 700;
  justify-content: space-between;
`;

export const BannerContainer = styled.div`
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: ${colors.lightBrown};
  background-color: ${colors.lightYellow};
  border-color: ${colors.lightYellow2};
  text-align: center;
  font-size: 14px;
`;

export const QuillContainer = styled.div.attrs(({ className }) => ({ className }))``;

export const QuillButton = styled.button.attrs(({ className }) => ({ className }))``;

export const CategorySelectContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  @media (max-width: 736px) {
    width: 100%;
  }
`;
